import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-u11",
  "use": "icon-u11-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-u11\">\n  <g transform=\"matrix(1 0 0 1 -18 -36 )\">\n    <path d=\"M 25 36  C 28.92 36  32 39.08  32 43  C 32 46.92  28.92 50  25 50  C 21.08 50  18 46.92  18 43  C 18 39.08  21.08 36  25 36  Z \" fill-rule=\"nonzero\" fill=\"#8babd4\" stroke=\"none\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol